import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { Helmet } from "react-helmet";
import aboutImg from "../img/aboutus.jpg";

const About = () => {
  return (
    <>
      {/* SEO */}
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          About EBS Software Solution | Custom Software & ERP Development Company
        </title>
        <meta
          name="description"
          content="EBS Software Solution is a trusted software development company based in Siliguri, India, delivering custom business software, ERP solutions, GST-enabled systems, and IT infrastructure services."
        />
      </Helmet>

      {/* Hero Section */}
      <div
        style={{
          background: `linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url(${aboutImg}) center/cover no-repeat`,
          minHeight: "50vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Container>
          <Row>
            <Col lg={8}>
              <h1 style={{ color: "#fff", fontWeight: 800 }}>
                About EBS Software Solution
              </h1>
              <p
                style={{
                  color: "#e0e0e0",
                  fontSize: "18px",
                  marginTop: 15,
                  lineHeight: 1.6,
                }}
              >
                Delivering reliable, scalable, and business-driven software
                solutions for modern enterprises.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      {/* About Content */}
      <Container className="py-5">
        {/* Who We Are */}
        <Row className="mb-5">
          <Col lg={12} className="text-center">
            <h2 style={{ fontWeight: 700 }}>Who We Are</h2>
            <p
              style={{
                maxWidth: 900,
                margin: "15px auto",
                fontSize: 16,
                lineHeight: 1.8,
              }}
            >
              <strong>EBS Software Solution</strong> is a well-established
              software development company headquartered in Siliguri, West
              Bengal (India). We specialize in designing and delivering
              customized business software that helps organizations improve
              efficiency, maintain compliance, and scale with confidence.
            </p>
          </Col>
        </Row>

        {/* Company Overview */}
        <Row className="mb-4">
          <Col lg={12}>
            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              We serve businesses across diverse industries by developing
              purpose-built software solutions including ERP systems,
              GST-enabled accounting software, inventory management systems,
              HR & payroll solutions, hospitality software, healthcare systems,
              retail POS solutions, and industry-specific applications.
            </p>

            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              Our focus is not only on software development but also on long-term
              partnership. From requirement analysis and implementation to
              training, customization, upgrades, and support, we provide
              end-to-end services that ensure smooth adoption and measurable
              business value.
            </p>
          </Col>
        </Row>

        {/* IT Infrastructure */}
        <Row className="mb-5">
          <Col lg={12}>
            <Card className="border-0 shadow-sm">
              <Card.Body>
                <h4 style={{ fontWeight: 700, marginBottom: 15 }}>
                  IT Infrastructure & Integration Solutions
                </h4>
                <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
                  Our IT infrastructure and integration software enables
                  seamless connectivity between applications, departments, and
                  business processes. By simplifying complex IT environments,
                  we help organizations operate more efficiently and respond
                  faster to changing business needs.
                </p>
                <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
                  Compared to traditional custom-coded integrations, our
                  standardized and modular solutions significantly reduce
                  implementation time and maintenance costs. This approach
                  allows businesses to focus on innovation instead of managing
                  technical complexity.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Services */}
        <Row className="mb-5">
          <Col lg={12}>
            <h3 style={{ fontWeight: 700, marginBottom: 25 }}>
              What We Offer
            </h3>
          </Col>

          {[
            "Custom software design and development",
            "ERP, GST-enabled accounting, and business automation solutions",
            "Software installation, deployment, and implementation",
            "Project management and technical consulting",
            "User training for management and operational staff",
            "Software customization to meet business-specific requirements",
            "Ongoing maintenance, upgrades, and customer support",
          ].map((service, index) => (
            <Col lg={6} key={index} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body>
                  <p style={{ marginBottom: 0, fontSize: 15 }}>
                    ✔ {service}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Why Choose Us */}
        <Row className="mb-4">
          <Col lg={12}>
            <h3 style={{ fontWeight: 700, marginBottom: 20 }}>
              Why Choose EBS Software Solution
            </h3>
            <p style={{ textAlign: "justify", lineHeight: 1.8 }}>
              Our clients choose us for our commitment to quality, reliability,
              and transparency. We may not claim to be the largest software
              company, but we pride ourselves on being a dependable technology
              partner that understands business challenges and delivers
              practical, cost-effective solutions.
            </p>
          </Col>
        </Row>

        {/* Closing */}
        <Row>
          <Col lg={12}>
            <p
              style={{
                textAlign: "center",
                fontWeight: 600,
                fontSize: 17,
              }}
            >
              At EBS Software Solution, technology is not just about software —
              it’s about enabling sustainable business growth.
            </p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default About;
